export const localStorageHelper = {
  saveJson: (location, values) => {
    if (!localStorage) {
      return;
    }

    try {
      localStorage.setItem(location, JSON.stringify(values));
    } catch (e) {
      // There could be a case where we are not allowed to store anymore,
      // so let's just catch this since this is a convenience
      console.warning(e);
    }
  },

  retreiveJson: (location) => {
    if (!localStorage) {
      return {};
    }

    let savedData = localStorage.getItem(location);

    if (!savedData) {
      return {};
    }

    try {
      savedData = JSON.parse(savedData);
    } catch (e) {
      savedData = {};
    }

    return savedData;
  },

  clear: () => {
    if (!localStorage) {
      return;
    }

    localStorage.clear();
  }
};


export const updateGlobalCSRFToken = () => {
  const newToken = Cookies.get('csrftoken'); // eslint-disable-line no-undef

  if (global.CSRF_TOKEN !== newToken) {
    global.CSRF_TOKEN = newToken;
  }
};
